import { render, staticRenderFns } from "./CompanyUserForm.vue?vue&type=template&id=524dba33"
import script from "./CompanyUserForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyUserForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyUserForm.vue?vue&type=style&index=0&id=524dba33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports